import styled from "@emotion/styled";
import { TypeRampV2 } from "../../typography";

export const ChipLabelStyled = styled(TypeRampV2)`
    padding: 0 6px 0 4px;
    letter-spacing: 0.2px;
    word-break: break-all;
`;
